"use client";

import { ResponsiveAds } from "@costar-ui/news";
import { AdConfigs } from "@costar-ui/news";

export const ArticleAds = (props: { articleAdConfigs: AdConfigs }) => {
  const { articleAdConfigs } = props;
  return <ResponsiveAds adConfigs={articleAdConfigs} />;
};
